/**
 * @module support/api
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { SETTINGS } from '@environment/settings';

/**
 * API Map for resolving API endpoints
 * @access public - global
 */
export const API_MAP = {
  AEM_MANIFEST: './assets/content/manifest.json',
  AEM_ROUTES: './assets/content/routes.json',
  998: `${SETTINGS.MOCK_ENDPOINT}/998/mock-items.json`,
  999: `${SETTINGS.MOCK_ENDPOINT}/999/mock-item-details.json`,
};
